import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import styles from "./ItemFlag.module.scss";
export const ItemFlag = ({ icon, text, className }) => {
    return (_jsxs("div", { className: classNames(styles.container, className), children: [icon({ width: "27px", height: "27px", className: styles.icon }), _jsx("span", { className: styles.caption, children: text })] }));
};
//# sourceMappingURL=ItemFlag.js.map